<template>
  <div class="overflow-x-scroll">
    <table class="w-full">
      <tr class="text-left border-b">
        <th class="p-3">ID</th>
        <th class="p-3">Name</th>
        <th class="p-3">Email</th>
        <th class="p-3 text-center"></th>
        <th class="p-3 text-center"></th>
        <th class="p-3 text-center"></th>
        <th class="p-3 text-center"></th>
      </tr>
      <tr v-for="(user, i) in users" :key="user.id" :class="{ 'bg-grey-lighter': i % 2 !== 0 }">
        <td class="p-3 whitespace-no-wrap text-sm">
          {{ user.id }}
        </td>
        <td class="p-3 whitespace-no-wrap text-sm">
          {{ user.title }} {{ user.name }}
        </td>
        <td class="p-3 whitespace-no-wrap text-sm">
          {{ user.email }}
        </td>
        <td class="py-3 whitespace-no-wrap text-center">
          <span v-if="user.referral_system" class="mx-2 rounded-full text-xs bg-tertiary text-white px-3 py-1">referral system</span>
        </td>
        <td class="py-3 whitespace-no-wrap text-center">
          <span v-if="user.knowledge_hub" class="mx-2 rounded-full text-xs bg-tertiary text-white px-3 py-1">knowledge hub</span>
        </td>
        <td class="py-3 whitespace-no-wrap text-center">
          <i v-if="user.type <= 4" class="mx-2 fas fa-fw fa-star text-secondary"></i>
        </td>
        <td class="p-3 whitespace-no-wrap text-center">
          <button class="mr-3" @click="$emit('select', user)">
            <i class="far fa-fw fa-edit text-grey-darker"></i>
          </button>
          <button @click="$emit('delete', user)">
            <i class="far fa-fw fa-trash-alt text-grey-darker"></i>
          </button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ['users']
}
</script>
